"use client";

import { Modal } from "@mantine/core";

import { Button, Stack, Text } from "@/components/ui/elements";

type Props = {
  opened: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * 氏名が日本人の一般的な表記と異なるのに国籍が「日本」のまま保存されようとしたときの確認ダイアログ。
 * 帰化・国際結婚などで氏名が非典型な日本国籍のワーカーもいるため、保存自体は拒否せず注意喚起にとどめる。
 */
export function NationalityConfirmModal({
  opened,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title="国籍の確認"
      centered
      size="md"
    >
      <Stack gap="md">
        <Text size="sm">
          入力されたお名前は、日本の一般的なお名前の表記と異なっています。国籍を「日本」のまま保存してよろしいですか。
        </Text>
        <Text size="sm" c="dimmed">
          日本以外の国籍の方は、就労できるかどうかの確認のため、国籍を正しくご入力ください。
        </Text>
        {/* Button の既定は size="lg" で、横並びだと文言が長く折り返すため縦に積む */}
        <Stack gap="xs">
          <Button
            type="button"
            color="teal"
            size="md"
            fullWidth
            onClick={onConfirm}
          >
            日本のまま保存する
          </Button>
          <Button
            type="button"
            variant="outline"
            color="gray"
            size="md"
            fullWidth
            onClick={onCancel}
          >
            国籍を入力し直す
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
}
